import classNames from "classnames";
import { Link as L, NavLink as NL } from "react-router-dom";
import config from "config";
import getEnsureLocalhostPort from "helpers/getEnsureLocalhostPort.ts";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import useNavigateWithoutPageReload from "./hooks/useNavigateWithoutPageReload.ts";

import "./Link.scss";

const makeLink = (Component) => (props) => {
  const { getPath } = useContent();
  const className = classNames(["jm-link", props.className]);
  const to = getPath(props.to);
  return <Component {...{ ...props, to, className }} />;
};

export const LinkToPhone = ({ classes, phone, children }) => {
  const className = classNames(["jm-link", classes]);
  return (
    <a href={`tel:${phone}`} className={className} target={"_self"}>
      {children}
    </a>
  );
};

export const LinkToEmail = ({
  classes,
  email,
  children,
  subject = null,
  body = null,
}) => {
  const className = classNames(["jm-link", classes]);
  const mailBody = body ? "&body=" + body : null;
  const mailSubject = subject ? "?subject=" + subject : null;
  return (
    <a
      href={`mailto:${email}${mailSubject}${mailBody}`}
      className={className}
      target={"_self"}
    >
      {children}
    </a>
  );
};
export const LinkToNewTab = ({
  page,
  classes,
  style,
  isNewTab = false,
  fullUrl = false,
  ariaLabel,
  children,
  ...props
}) => {
  const { getPath } = useContent();
  const navigate = useNavigateWithoutPageReload();
  const allClasses = classNames(["jm-link", classes]);
  if (
    fullUrl &&
    page.indexOf("https://") === -1 &&
    page.indexOf("http://") === -1
  ) {
    if (page.indexOf("www") === -1) {
      page = "https://www." + page;
    } else {
      page = "https://" + page;
    }
  }

  let altString = "Link";

  if (typeof children === "string") {
    altString = children;
  }

  // check if childnre is an array and if it is take first string only
  if (Array.isArray(children)) {
    altString = children[0];
  }

  // Ensure localhost has port 3000
  const baseUrl = getEnsureLocalhostPort(config.baseurl);

  const handleCLick = (event) => {
    // handle passed onClick if exist
    if (props.onClick) {
      props.onClick();
    }

    navigate({
      page,
      isNewTab,
      event,
    });
  };

  return (
    <a
      data-navigate="true"
      href={`${!fullUrl ? `${baseUrl}` + getPath() : ""}${page}`}
      className={allClasses}
      target={isNewTab ? "_blank" : "_self"}
      style={style}
      aria-label={ariaLabel || altString}
      rel="noreferrer"
      alt={altString}
      {...props}
      onClick={handleCLick}
    >
      {children}
    </a>
  );
};

const Link = makeLink(L);
export const NavLink = makeLink(NL);

export default Link;
